// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentError {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 40px 20px;
  color: var(--color_neutral_0);
  text-align: center;
}
.DocumentError .DocumentError-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  max-width: 400px;
}
.DocumentError .DocumentError-content .DocumentError-title {
  margin: 0;
  color: var(--color_neutral_0);
}
.DocumentError .DocumentError-content .DocumentError-description {
  margin: 0;
  color: var(--color_neutral_300);
  font-size: 14px;
  line-height: 1.5;
}
.DocumentError .DocumentError-content .DocumentError-button {
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/modules/documents/document-error/document-error.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AACJ;AACI;EACE,SAAA;EACA,6BAAA;AACN;AAEI;EACE,SAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;AAAN;AAGI;EACE,eAAA;AADN","sourcesContent":[".DocumentError {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 40px 20px;\n  color: var(--color_neutral_0);\n  text-align: center;\n\n  .DocumentError-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    max-width: 400px;\n\n    .DocumentError-title {\n      margin: 0;\n      color: var(--color_neutral_0);\n    }\n\n    .DocumentError-description {\n      margin: 0;\n      color: var(--color_neutral_300);\n      font-size: 14px;\n      line-height: 1.5;\n    }\n\n    .DocumentError-button {\n      margin-top: 8px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
